export default __webpack_public_path__ + "static/media/warning--triple-lanes-with-directions--g1.586f9802.png";